import React, { useState } from 'react'
import './styles.scss'

const xmove = 21.3
const ymove = 17.5

const CENTERS_7 = [
  [xmove * 0.5, -ymove], // t r
  [-xmove * 0.5, -ymove], // t l

  [xmove, 0], // m r
  [0, 0], // m
  [-xmove, 0], // m l

  [xmove * 0.5, ymove], //b r
  [-xmove * 0.5, ymove] // b l
]

export const DataElement = ({
  name,
  code,
  data,
  setHovered,
  notinteraktive = false
}: {
  code: string
  name: string
  data: { color: string; prop: string }[] | undefined
  setHovered: React.Dispatch<
    React.SetStateAction<
      | {
          data: {
            name: string
            props: { unit: string; prop: string; val: string; color: string }[]
          }
          pos: [number, number]
        }
      | undefined
    >
  >
  notinteraktive?: boolean
}) => {
  const [hovered, sethovered] = useState(false)

  return (
    <>
      <div className={'DataElementContainer ' + (hovered ? 'hovered' : '')}>
        <svg
          viewBox='0 0 70 60'
          className='DataElement'
          onMouseMove={e => {
            const rect = e.currentTarget?.parentNode?.parentNode.parentNode.getBoundingClientRect()
            const x = e.pageX - rect.left + 10
            const y = e.nativeEvent.y - rect.top + 10
            if (!notinteraktive) {
              setHovered({ data: { name, props: data }, pos: [x, y] })
              sethovered(true)
            }
          }}
          onMouseLeave={() => {
            setHovered(undefined)
            sethovered(false)
          }}
        >
          <g transform={`translate(${xmove * 1.65},${ymove * 3})`}>
            <line
              x1={-xmove * 0.5 + 4}
              x2={xmove * 0.5 - 4}
              y1={ymove - 0.5}
              y2={ymove - 0.5}
              className={'elementline'}
            />
            {data &&
              data
                .sort((a, b) => a.pos - b.pos)
                .map((c, i) => (
                  <g
                    key={i}
                    transform={`translate(${CENTERS_7[i][0]},${CENTERS_7[i][1]})`}
                  >
                    {/* <path
                      d={
                        'M12.5-22.7A12.3,12.3,0,0,1,6.6-12.3C4.2-11,1.4-8.5,1.4,0H-1.4c0-8.5-2.8-11-5.2-12.3a12.3,12.3,0,0,1-5.9-10.4A12.4,12.4,0,0,1,0-35,12.4,12.4,0,0,1,12.5-22.7Z'
                      }
                      fill={c.color}
                      stroke={'#fff'}
                      opacity={1}
                      className={c.prop + ' - ' + c.val}
                    /> */}
                    <circle
                      cy={-22}
                      r={12}
                      fill={c.color}
                      stroke={'#fff'}
                      opacity={1}
                      className={c.prop + ' - ' + c.val}
                    />
                    <path
                      transform={`translate(0,${-22})`}
                      fill='#fff'
                      d={ICONS[c.propid]}
                    />
                  </g>
                ))}
          </g>
        </svg>
      </div>
      {/* <div className='DataElementFlag'>
        <img src={require('images/flags/' + code + '.png')} />
      </div> */}
      <div className={'DataElementLabel ' + (code === 'CH' ? 'mark' : '')}>
        {name}
      </div>
    </>
  )
}
// 'M2.913,3.581v-5.523c0-1.609-1.304-2.913-2.913-2.913c-1.609,0-2.913,1.304-2.913,2.913v5.523h-0.584v1.274 h0.584h5.827h0.584V3.581H2.913z M-1.788-1.503h3.577v0.769h-3.577V-1.503z',

const ICONS = {
  vacc:
    'M5.343-0.25v-1.604H-6.166v1.604h-2v-1.337h-0.5v3.174h0.5V0.25h2v1.604H5.343V0.25h3.322v-0.5H5.343z M-5.666-1.354h6.784v2.708h-6.784V-1.354z',

  tests:
    'M1.829,1.355C3.018,1.82,4.775,2.509,6.213,2.509c0.581,0,1.109-0.112,1.527-0.397 C8.339,1.703,8.643,0.993,8.643,0S8.339-1.703,7.74-2.112C6.287-3.102,3.496-2.008,1.829-1.355 C1.378-1.178,0.866-0.977,0.743-0.977h-9.386v0.5l9.386-0.006v0.006c0.138,0,0.291,0.196,0.291,0.478S0.881,0.477,0.743,0.477 h-9.386v0.5h9.386C0.866,0.977,1.378,1.178,1.829,1.355z',

  excessmort:
    'M0-6.946c-3.038,0-5.5,2.462-5.5,5.5c0,2.03,1.1,3.801,2.736,4.754v1.637h0.675V3.733h0.235h0.251v0.083v1.13 h0.437V3.929V3.733h0.486v0.278v0.935h0.437V4.048V3.733h0.486v0.315v0.898H0.68V4.011V3.733h0.486v0.196v1.016h0.437v-1.13V3.733 h0.251h0.235v1.213h0.675V3.309C4.4,2.355,5.5,0.584,5.5-1.446C5.5-4.483,3.038-6.946,0-6.946z M-3.379,0.105 c0-0.712,0.577-1.29,1.29-1.29s1.29,0.577,1.29,1.29c0,0.712-0.578,1.29-1.29,1.29S-3.379,0.817-3.379,0.105z M2.089,1.395 c-0.712,0-1.29-0.577-1.29-1.29c0-0.712,0.577-1.29,1.29-1.29c0.712,0,1.29,0.577,1.29,1.29C3.379,0.817,2.801,1.395,2.089,1.395z',
  sequenced:
    'M4.444-0.405C3.279-1.874,1.935-3.349,0-3.349c-1.939,0-3.281,1.476-4.445,2.945 c-1.181-1.515-2.298-2.945-3.9-2.945v0.5c1.36,0,2.405,1.34,3.512,2.759C-4.81-0.06-4.786-0.03-4.763,0 C-4.786,0.03-4.81,0.06-4.833,0.089c-1.104,1.419-2.147,2.76-3.513,2.76v0.5c1.606,0,2.721-1.429,3.901-2.944 C-3.28,1.874-1.936,3.349,0,3.349c1.939,0,3.282-1.476,4.445-2.945C5.626,1.92,6.742,3.349,8.345,3.349v-0.5 c-1.361,0-2.405-1.34-3.512-2.759C4.81,0.06,4.786,0.029,4.762-0.001C4.785-0.03,4.809-0.06,4.832-0.089 c1.105-1.419,2.148-2.76,3.514-2.76v-0.5C6.739-3.349,5.624-1.92,4.444-0.405z M0,2.849c-1.75,0-2.976-1.388-4.127-2.848 C-2.979-1.46-1.755-2.849,0-2.849c1.75,0,2.976,1.388,4.127,2.849C2.977,1.461,1.753,2.849,0,2.849z M-0.263-1.784h0.5v3.542h-0.5 V-1.784z M-1.733-1.105h0.5V1.08h-0.5V-1.105z M1.207-1.105h0.5V1.08h-0.5V-1.105z',
  schools:
    'M-3.028-5.946c-0.682,0-1.248,0.494-1.366,1.142H-4.42v0.25V5.946h7.698V-4.803h-7.148 c0.11-0.368,0.438-0.642,0.841-0.642H3.92v9.999h0.5V-5.946H-3.028z M-2.686-1.768v-0.575h3.889v0.575H-2.686z',
  stringency:
    'M7.815-2.87c0-1.312-0.844-2.38-1.88-2.38C5.646-5.25,5.357-5.164,5.1-5L4.85-4.84L4.735-4.747v0.006 c-0.371,0.252-0.78,0.486-1.217,0.694C1.219-2.954-1.347-2.976-3.647-4.116c-0.344-0.164-0.685-0.358-1.019-0.579l0.015-0.029 L-5.1-5.001C-5.36-5.166-5.64-5.25-5.935-5.25c-1.036,0-1.88,1.067-1.88,2.38c0,0.444,0.099,0.877,0.285,1.251l2.304,4.664	l0.117,0.228c0.183,0.365,0.438,0.659,0.764,0.862l0.422,0.211C-2.682,4.946-1.36,5.25,0.005,5.25c1.297,0,2.567-0.28,3.774-0.833		l0.002-0.001c0.174-0.082,0.347-0.164,0.514-0.252l0.087-0.045c0.283-0.186,0.536-0.472,0.736-0.837L5.41,2.68H5.408L7.54-1.631 C7.717-1.997,7.815-2.437,7.815-2.87z M-2.864,1.552c0.027-0.138,0.134-0.221,0.24-0.186c0.853,0.282,1.737,0.426,2.626,0.426 s1.773-0.143,2.626-0.426c0.106-0.035,0.213,0.049,0.24,0.186C2.894,1.69,2.83,1.83,2.725,1.865	C1.84,2.158,0.924,2.306,0.002,2.306s-1.838-0.149-2.723-0.441C-2.827,1.83-2.891,1.69-2.864,1.552z M2.725-0.068	C1.839,0.225,0.923,0.374,0.002,0.374c-0.922,0-1.838-0.148-2.723-0.441c-0.106-0.035-0.17-0.175-0.143-0.313 c0.027-0.138,0.134-0.221,0.24-0.186c0.854,0.282,1.737,0.426,2.626,0.426c0.889,0,1.772-0.143,2.626-0.426 c0.106-0.035,0.213,0.048,0.24,0.186C2.894-0.243,2.83-0.103,2.725-0.068z M-4.664,3.045l-2.418-4.887 c-0.15-0.301-0.233-0.667-0.233-1.028c0-1.037,0.619-1.88,1.38-1.88c0.2,0,0.386,0.056,0.569,0.173l0.066,0.041l-0.004,0.009 l0.175,0.123c0.357,0.249,0.725,0.463,1.094,0.649v7.487l-0.066-0.033C-4.326,3.557-4.52,3.332-4.664,3.045z M7.091-1.851 l-2.31,4.67L4.661,3.077C4.506,3.35,4.317,3.564,4.135,3.686L4.068,3.719c-0.054,0.029-0.109,0.053-0.163,0.08v-7.484 c0.438-0.219,0.852-0.458,1.224-0.72l0.24-0.174C5.547-4.692,5.738-4.75,5.935-4.75c0.761,0,1.38,0.843,1.38,1.88 C7.315-2.511,7.235-2.148,7.091-1.851z',
  gdp:
    'M0,5c2.761,0,5-2.239,5-5S2.761-5,0-5c-2.761,0-5,2.239-5,5S-2.761,5,0,5z M-1.713-2.448 c0.45-0.566,1.078-0.85,1.882-0.85c0.536,0,0.982,0.123,1.339,0.37C1.864-2.681,2.142-2.338,2.343-1.9L1.749-1.535 c-0.128-0.329-0.326-0.592-0.594-0.79C0.888-2.523,0.559-2.622,0.169-2.622c-0.481,0-0.871,0.143-1.169,0.429 C-1.299-1.906-1.485-1.525-1.557-1.05H0.79v0.612h-2.384v0.877H0.79V1.05h-2.348c0.079,0.475,0.266,0.856,0.562,1.142 C-0.7,2.479-0.312,2.622,0.169,2.622c0.402,0,0.74-0.106,1.014-0.32c0.274-0.213,0.478-0.493,0.613-0.84l0.593,0.393 C2.291,2.061,2.175,2.253,2.041,2.43c-0.134,0.177-0.291,0.329-0.47,0.457c-0.18,0.128-0.386,0.228-0.617,0.301 s-0.493,0.11-0.786,0.11c-0.804,0-1.431-0.283-1.882-0.85C-2.163,1.882-2.389,1.066-2.389,0S-2.163-1.882-1.713-2.448z'
}
